import { http } from '@/http'

export default {
  list(data, params) {
    return http.post('/api/v1/audit-logs/list', data, {params})
  },
  download(data) {
    return http.post('/api/v1/audit-logs/xlsx', data, {responseType: 'blob'})
  },
  // Detalle con el diff campo por campo. El listado no lo trae: se pide solo
  // al abrir el modal (DEF-ADM-023 §3.4).
  get(id) {
    return http.get(`/api/v1/audit-logs/${id}`)
  }
}
